import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { XIcon, ArrowRightIcon } from 'lucide-react';
import { BRAND, GET_STARTED_URL } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { VideoPlayer } from './VideoPlayer';
type VideoLightboxProps = {
  onClose: () => void;
};

/**
 * Desktop lightbox that plays the demo at min(90vw, 1200px) so the product UI
 * is legible. The close control sits above the player — never on top of it.
 */
export function VideoLightbox({
  onClose
}: VideoLightboxProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const previousFocus = document.activeElement as HTMLElement | null;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus();
    };
  }, [onClose]);
  return createPortal(<div role="dialog" aria-modal="true" aria-label="DiligenceGPT™: Venture Capital video" className="fixed inset-0 z-[60] flex items-center justify-center bg-[#0A0A0A]/85 p-4" onClick={onClose} data-id="element-178" data-mp="16wlpo95rb9by">
      <div className="flex flex-col gap-3" style={{
      width: 'min(90vw, 1200px)'
    }} onClick={event => event.stopPropagation()} data-id="element-179" data-mp="1ku1yfrbizf6v">
        <div className="flex items-center justify-between gap-4" data-id="element-180" data-mp="1prk5td9w9mcr">
          <p className="text-sm font-semibold text-white" data-id="element-181" data-mp="1bt3rp19pctkl">
            {BRAND.product} <span className="font-normal text-white/70" data-id="element-182" data-mp="1fupb75gqs63r">· Product overview</span>
          </p>
          <button ref={closeRef} type="button" onClick={onClose} aria-label="Close video" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/20 text-white transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-183" data-mp="e6yrgaedk7y">
            <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-184" data-mp="1xd5u1asv3fan" />
          </button>
        </div>

        <VideoPlayer data-id="element-185" data-mp="1se2qxvwfzj5b" />

        <div className="flex justify-end" data-id="element-186" data-mp="1semafh1qqflg">
          <CtaButton href={GET_STARTED_URL} event="primary_cta_click" eventParams={{
          placement: 'video_lightbox',
          cta: 'try_pitch_deck_screener'
        }} data-id="element-187" data-mp="1sdsym1nxczwg">
            Try Pitch Deck Screener
            <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-188" data-mp="1jclagcf4hfg3" />
          </CtaButton>
        </div>
      </div>
    </div>, document.body);
}